<div class="asset-cards-container" (click)="closeMenu()">
  <div class="filter-section">
    <div class="filter-group">
      <select class="filter-select" [(ngModel)]="selectedSites">
        <option value="All Sites">All Sites</option>
      </select>

      <select class="filter-select" [(ngModel)]="selectedApplications">
        <option value="All Applications">All Applications</option>
      </select>
    </div>

    <div class="view-controls">
      <div class="legend-items">
        <div class="legend-item">
          <span class="legend-dot asset-idle"></span>
          <span>Asset Idle</span>
        </div>
        <div class="legend-item">
          <span class="legend-dot asset-running"></span>
          <span>Asset Running</span>
        </div>
        <div class="legend-item">
          <span class="legend-dot healthy"></span>
          <span>Healthy</span>
        </div>
        <div class="legend-item">
          <span class="legend-dot unhealthy"></span>
          <span>Unhealthy</span>
        </div>
        <div class="legend-item">
          <span class="legend-dot offline"></span>
          <span>Offline</span>
        </div>
        <div class="legend-item">
          <span class="legend-dot out-of-service"></span>
          <span>Out of service</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Loader -->
  <div class="loader-container" *ngIf="assetLoader">
    <div class="spinner"></div>
    <p>Loading assets...</p>
  </div>

  <!-- Asset Cards Grid -->
  <div class="assets-grid" *ngIf="!assetLoader">
    <div class="asset-card" *ngFor="let asset of filteredAssetList; let i = index"
      [style.background-color]="asset.overall_health" [class.alert-blink]="asset.overall_health === '#f8d7da'">
      <!-- Card Header -->
      <div class="card-header">
        <h3 class="card-title">{{ asset.subsystem_name }}</h3>

        <div class="status-indicator">
          <span class="status-label">{{ getStatusLabel(asset.overall_live_status) }}</span>
          <div class="status-dot" [style.background-color]="getStatusColor(asset.overall_live_status)"></div>
        </div>
        <div class="menu-container">
          <button class="menu-button" (click)="toggleMenu($event, i)" aria-label="More options">
            ⋮
          </button>

          <div class="menu-dropdown" *ngIf="openMenuIndex === i">
            <button class="menu-item" (click)="editAsset($event, asset, i)">
              <span class="menu-icon">✏️</span>
              <span>Edit</span>
            </button>
            <button class="menu-item delete" (click)="deleteAsset($event, asset, i)">
              <span class="menu-icon">🗑️</span>
              <span>Delete</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Asset Image with Sensors -->
      <div class="card-body" (click)="openAssetDetails(i)">
        <div class="image-container">
          <img [src]="asset.Image_path" [alt]="asset.subsystem_name" class="asset-image" [id]="'asset-image-' + i" />

          <!-- Sensor Markers -->
          <div *ngFor="let sensor of asset.sensors" class="sensor-marker"
            [class.pulsing-circle]="sensor.color === '#ff2a1b'" [class.border-yellow]="sensor.color === '#faa700'"
            [class.border-green]="sensor.color === '#72ff13'" [style.top.%]="sensor.yPercentage"
            [style.left.%]="sensor.xPercentage" [style.background-color]="sensor.color" [title]="showTooltip(sensor)">
            <div class="sensor-label">
              {{ sensor.sensorDNames }}
            </div>
            <img *ngIf="[0, 1].includes(sensor.asset_status)" src="./assets/wifion.png" class="sensor-wifi-icon"
              alt="WiFi On" />
            <img *ngIf="sensor.asset_status === 2" src="./assets/wifioff.png" class="sensor-wifi-icon" alt="WiFi Off" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div class="empty-state" *ngIf="!assetLoader && filteredAssetList.length === 0">
    <p>No assets found</p>
    <button class="btn-primary" (click)="openAssetDetails(-1)">
      Add Your First Asset
    </button>
  </div>
</div>